<template>
  <div class="mask-model" v-show="showMask">
    <div class="mask" @click="hide"></div>
    <div class="model-count">
      <div class="amen-tit">提示</div>
      <div class="count" :style="{ color: titleColoe }">{{ maskTitle }}</div>
      <div class="btm-box">
        <div
          v-show="btnType == 1"
          class="btns cancel"
          @click="hide"
          :style="{ color: cancelColor }"
        >
          取消
        </div>
        <div
          class="btns confirm"
          @click="confirm"
          :style="{ color: confirmColor }"
        >
          确定
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    maskTitle: {
      //提示内容
      type: String,
      default: '提示消息',
    },
    titleColoe: {
      //提示信息字体颜色
      type: String,
      default: '#666666',
    },
    confirmColor: {
      //确定按钮字体颜色
      type: String,
      default: '#007AFF',
    },
    cancelColor: {
      //取消按钮字体颜色
      type: String,
      default: '#666666',
    },
    btnType: {
      //1显示取消按钮
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      showMask: false,
    };
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    show: function() {
      this.showMask = true;
    },
    hide: function() {
      this.$emit('cancel');
      this.showMask = false;
    },
    confirm: function(e) {
      this.showMask = false;
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped>
.mask-model {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.mask-model .mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
}
.model-count {
  width: 500px;
  padding: 10px 0 50px 0;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
  transform: translate(-50%, -50%);
}
.amen-tit {
  font-weight: bold;
  font-size: 20px;
  line-height: 60px;
  text-align: center;
  background: #ffffff;
}
.count {
  padding: 20px 30px 50px;
  color: #666666;
  font-size: 16px;
  text-align: center;
}
.btm-box {
  display: flex;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  border-top: 1px solid #f5f5f5;
}
.btm-box .btns {
  flex: 1;
  box-sizing: border-box;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}
.btm-box .btns.confirm {
  color: #007aff;
}
.btm-box .btns.cancel {
  border-right: 1px solid #f5f5f5;
  color: #666666;
}
</style>
